import React from 'react';
import { Button } from 'reactstrap';

const Pagination = ({ pagination, onPageChange }) => {
  if (!pagination || pagination.totalPages <= 1) {
    return null;
  }

  const { currentPage, totalPages, hasNextPage, hasPreviousPage } = pagination;

  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5; // Show max 5 page numbers
    
    if (totalPages <= maxVisible) {
      // Show all pages if total pages is less than max visible
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Show pages around current page
      let startPage = Math.max(1, currentPage - 2);
      let endPage = Math.min(totalPages, currentPage + 2);

      if (currentPage <= 3) {
        startPage = 1;
        endPage = 5;
      } else if (currentPage >= totalPages - 2) {
        startPage = totalPages - 4;
        endPage = totalPages;
      }

      if (startPage > 1) {
        pages.push(1);
        if (startPage > 2) pages.push('...');
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      if (endPage < totalPages) {
        if (endPage < totalPages - 1) pages.push('...');
        pages.push(totalPages);
      }
    }

    return pages;
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages && page !== currentPage) {
      onPageChange(page);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center mt-4 mb-4">
      <div className="d-flex align-items-center gap-2">
        <Button
          color="secondary"
          size="sm"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={!hasPreviousPage}
          style={{ minWidth: '80px' }}
        >
          Previous
        </Button>

        <div className="d-flex gap-1">
          {getPageNumbers().map((page, index) => {
            if (page === '...') {
              return (
                <span key={`ellipsis-${index}`} className="px-2">
                  ...
                </span>
              );
            }

            return (
              <Button
                key={page}
                color={page === currentPage ? 'primary' : 'outline-secondary'}
                size="sm"
                onClick={() => handlePageChange(page)}
                style={{ minWidth: '40px' }}
              >
                {page}
              </Button>
            );
          })}
        </div>

        <Button
          color="secondary"
          size="sm"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={!hasNextPage}
          style={{ minWidth: '80px' }}
        >
          Next
        </Button>
      </div>

      <div className="ms-4 text-muted">
        <small>
          Page {currentPage} of {totalPages} ({pagination.totalItems} total items)
        </small>
      </div>
    </div>
  );
};

export default Pagination;

